import useKeyPress from "./useKeyPress"
import { useEffect } from "react"

interface UseEscapeKeyOptions {
  targetElement?: EventTarget | null
}

function useEscapeKey(callback: () => void, options: UseEscapeKeyOptions = {}) {
  const { targetElement = null } = options
  const isEscapePressed = useKeyPress("Escape", { targetElement })

  useEffect(() => {
    if (isEscapePressed) {
      callback()
    }
  }, [isEscapePressed, callback])
}

export default useEscapeKey
